import React from "react";
import { Col, Space } from "antd";

import ManualList from "../../components/ManualList";
import CatalogList from "../../components/CatalogList";

function ReferenceManagement() {
    return (
        <div className="container">
            <Space size={30} direction="vertical" style={{ width: "100%" }}>
                <h3 className="title">자료실 관리</h3>
                <ManualList />
                <CatalogList />
            </Space>
        </div>
    );
}

export default ReferenceManagement;
